/* HI BAGS USA: accessible Apple-inspired desktop nav. Keeps original links as no-JS fallback. */
(() => {
  if (window.__hbAppleNavigationInstalled) return;
  window.__hbAppleNavigationInstalled = true;

  function initialise(nav) {
    if (nav.dataset.hbAppleInitialised === 'yes') return;
    nav.dataset.hbAppleInitialised = 'yes';
    const triggers = Array.from(nav.querySelectorAll('[data-hb-apple-trigger]'));
    const panels = Array.from(nav.querySelectorAll('[data-hb-apple-panel]'));
    const backdrop = nav.querySelector('[data-hb-apple-backdrop]');
    const host = nav.closest('.section-header');
    const header = nav.closest('.header-wrapper') || nav.closest('.header');
    const desktop = window.matchMedia('(min-width: 990px)');
    let opened = -1;
    let hoverTimer;

    function position() {
      const source = header || nav;
      nav.style.setProperty('--hb-apple-top', Math.max(0, source.getBoundingClientRect().bottom) + 'px');
    }

    function close(returnFocus) {
      const old = opened;
      opened = -1;
      triggers.forEach((a) => a.setAttribute('aria-expanded', 'false'));
      panels.forEach((panel) => panel.hidden = true);
      if (backdrop) backdrop.hidden = true;
      nav.classList.remove('is-open');
      if (host) host.classList.remove('hb-apple-header-open');
      if (returnFocus && old >= 0 && triggers[old]) triggers[old].focus();
    }

    function open(index) {
      if (!desktop.matches || !triggers[index] || !panels[index]) return;
      clearTimeout(hoverTimer);
      position();
      opened = index;
      triggers.forEach((a, i) => a.setAttribute('aria-expanded', i === index ? 'true' : 'false'));
      panels.forEach((panel, i) => panel.hidden = i !== index);
      if (backdrop) backdrop.hidden = false;
      nav.classList.add('is-open');
      if (host) host.classList.add('hb-apple-header-open');
    }

    triggers.forEach((trigger, i) => {
      trigger.addEventListener('click', (e) => {
        if (!desktop.matches || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        if (opened === i) close(); else open(i);
      });

      trigger.addEventListener('pointerenter', (e) => {
        if (!desktop.matches || e.pointerType === 'touch') return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => open(i), 150);
      });

      trigger.addEventListener('keydown', (e) => {
        if (!desktop.matches) return;
        let next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % triggers.length;
        if (e.key === 'ArrowLeft') next = (i + triggers.length - 1) % triggers.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = triggers.length - 1;
        if (next >= 0) {
          e.preventDefault();
          triggers[next].focus();
          if (opened >= 0) open(next);
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(i);
          const first = panels[i].querySelector('a');
          if (first) first.focus();
        }
      });
    });

    nav.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => close(), 220);
    });
    nav.addEventListener('pointerenter', () => clearTimeout(hoverTimer));
    panels.forEach((panel) => panel.addEventListener('pointerenter', () => clearTimeout(hoverTimer)));
    if (backdrop) backdrop.addEventListener('click', () => close());

    document.addEventListener('pointerdown', (event) => {
      if (opened !== -1 && !nav.contains(event.target)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (opened === -1) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      }
    });
    nav.addEventListener('focusout', (event) => {
      if (opened === -1) return;
      if (!event.relatedTarget || !nav.contains(event.relatedTarget)) {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (!nav.contains(document.activeElement)) close();
        }, 80);
      }
    });
    window.addEventListener('scroll', () => { if (opened !== -1) close(); }, {passive:true});
    window.addEventListener('resize', () => {
      if (!desktop.matches) close(); else if (opened !== -1) position();
    }, {passive:true});
    desktop.addEventListener('change', () => { if (!desktop.matches) close(); });
    document.addEventListener('shopify:section:unload', (event) => {
      if (host && host.contains(event.target)) close();
    });
  }

  function start() {
    document.querySelectorAll('[data-hb-apple-nav]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
